import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { availabilityShape, holdingShape } from '@bibliocommons/bc-prop-types';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibHoldingsEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import ResourcesList from 'app/components/bibs/shared/ResourcesList';

import './ElectronicResourceInfo.scss';

const { composeOnlineResourceClickEvent } = bibHoldingsEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

const handleClick = url => {
  sendAnalyticsEvents(
    composeOnlineResourceClickEvent({
      url,
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_TRANSACT
    })
  );
};

export default function ElectronicResourceInfo({ realtimeAvailability, holdings }) {
  const bibType = realtimeAvailability.get('bibType');

  if (bibType !== 'DIGITAL' && holdings.size > 0) {
    return (
      <div className="cp-electronic-resource">
        <div className="electronic-resource-label">
          <FormattedMessage id="bib_online_resource" />
        </div>
        <ResourcesList resources={holdings} handleClick={handleClick} />
      </div>
    );
  }

  return null;
}

ElectronicResourceInfo.propTypes = {
  realtimeAvailability: availabilityShape.isRequired,
  holdings: ImmutablePropTypes.listOf(holdingShape).isRequired
};
